import { post, get, del, put } from './requests'

export const createCaptureItem = key => payload =>
  post(
    ['api', 'captureItems'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const getCaptureItems = key =>
  get(['api', 'captureItems'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const updateCaptureItem = key => payload =>
  post(
    ['api', 'captureItems', 'update'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const updateCaptureItemDate = key => payload =>
  post(
    ['api', 'captureItems', 'updateDate'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const updateCaptureItemStatus = key => payload =>
  post(
    ['api', 'captureItems', 'updateStatus'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const deleteCaptureItem = key => payload =>
  del(
    ['api', 'captureItems', 'delete'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const setCaptureItemsOrder = key => payload =>
  post(
    ['api', 'captureItems', 'order'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const completeCaptureItem = key => payload =>
  post(
    ['api', 'captureItems', 'complete-item'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )



// WEBPACK FOOTER //
// ./src/services/capture-items.js